<template>
  <div>
    <!--about section area -->
    <div class="about_section pt-30">
        <div class="container extra-view">   
            <div class="row align-items-center">
                <div class="col-12">
                  <div class="page-content " v-html="currentItem.body"></div>
                </div>    
            </div>
        </div>    
    </div>
    <!--about section end-->
</div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
export default {
    data () {
        return {
            viewName: "about"
        }
    },
    computed: {
        ...mapState({
            currentItem: state => state.pages.selected,
            loading: state => state.pages.loading
        })
    },
    methods: {
      filter_data() {
        this.$store.dispatch("pages/getDetail", 'hoi-dap');
      }
    },
    mounted () {
      this.filter_data();
      this.$root.$off("REQUEST_REFRESH_DATA");
      this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>
<style>@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}</style>
